// extracted by mini-css-extract-plugin
export default {"languageSetting":"Language_languageSetting__zha7Z","languageSettingContent":"Language_languageSettingContent__B8fGZ","languageItemText":"Language_languageItemText__gWioS"};